import { create } from 'zustand';

const initialState = {
    isNewUser: false,
    needsRoleSelection: false,
    socialInfo: null,
    selectedRole: null,
    showRoleModal: false,
    showShopSelection: false,
    selectedShopId: null,
    selectedShopName: null,
};

const useSocialJoinStore = create((set) => ({
    ...initialState,
    setSocialLoginResult: (result) => {
        set({
            isNewUser: result.isNewUser,
            needsRoleSelection: result.needsRoleSelection,
            socialInfo: result.socialInfo,
            showRoleModal: result.needsRoleSelection,
        });
    },
    setSelectedRole: (role) => {
        set((state) => ({
            selectedRole: role,
            showRoleModal: false,
            showShopSelection: role === 'designer',
        }));
    },
    setSelectedShop: (shopId, shopName) => {
        set({
            selectedShopId: shopId,
            selectedShopName: shopName,
        });
    },
    closeRoleModal: () => {
        set({ showRoleModal: false });
    },
    closeShopSelection: () => {
        set({ showShopSelection: false });
    },
    reset: () => {
        set(initialState);
    },
}));

export default useSocialJoinStore;
